import { NOT_FOUND_PATHS } from '../enums/paths/app.paths';

export class NotFoundRouterHelper {
  private static readonly _notFoundPaths = new Set(NOT_FOUND_PATHS);

  static isNotFoundPath(path: string | readonly unknown[] | null | undefined): boolean {
    if (!path) {
      return false;
    }

    const normalizedPath = this._resolvePath(path);

    if (!normalizedPath) {
      return false;
    }

    return this._notFoundPaths.has(normalizedPath as (typeof NOT_FOUND_PATHS)[number]);
  }

  static shouldShow(path: string | readonly unknown[] | null | undefined): boolean {
    return !this.isNotFoundPath(path);
  }

  private static _resolvePath(path: string | readonly unknown[]): string | null {
    if (typeof path === 'string') {
      return this._normalizePath(path);
    }

    const firstSegment = path.find(
      segment =>
        typeof segment === 'string' && !segment.startsWith('.') && segment.trim().length > 0
    );

    return typeof firstSegment === 'string' ? this._normalizePath(firstSegment) : null;
  }

  private static _normalizePath(path: string): string {
    return path.replace(/^\/+|\/+$/g, '');
  }
}
